import React from "react";
import { SITE } from "../lib/site";

export default function PriceBanner() {
  return (
    <section data-testid="price-banner" className="bg-black text-white">
      <div className="container-soft py-16 md:py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex-1">
          <p className="overline text-white/60">Transparence</p>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-3 leading-tight">
            Obsèques à partir de <span className="italic">{SITE.priceFrom}</span>
          </h2>
          <p className="mt-4 text-white/70 max-w-xl leading-relaxed">
            Devis clair, détaillé et sans surprise. Nous vous accompagnons pour choisir
            la formule la plus adaptée, dans le respect de vos souhaits et de votre budget.
          </p>
        </div>
        <a
          href={SITE.phoneHref}
          data-testid="price-banner-call"
          className="inline-flex items-center justify-center px-8 py-4 bg-white text-black rounded-sm text-sm tracking-wide hover:bg-neutral-200 transition-all duration-300"
        >
          Demander un devis gratuit
        </a>
      </div>
    </section>
  );
}
